
import dotenv from 'dotenv';
import path from 'path';
if (typeof process.cwd != 'undefined') {
    let envPath = path.resolve(__dirname, '..', '..', '..', '.env');
    // console.log(`envPath`, envPath);
    dotenv.config({ path: envPath });
}
import crypto from 'crypto';

class CONFIG 
{
    private static _vars: CONFIG.Config;

    public static get vars(): CONFIG.Config 
    {
        if (!this._vars) {
            this._vars = this.MainConfig;
        }
        return this._vars;
    }

    private static get algorithm():string {
        return 'aes-256-cbc'; //Using AES encryption
    } 

    public static encrypt(input:string):string {
        let ivString = this.vars.ENCRYPT_IV;
        let keyString = this.vars.ENCRYPT_KEY;
        let keyBuffer = Buffer.from(keyString, 'hex');
        let ivBuffer = Buffer.from(ivString, 'hex');
        let cipher = crypto.createCipheriv(this.algorithm, Buffer.from(keyBuffer), ivBuffer);
        let encrypted = cipher.update(input);
        encrypted = Buffer.concat([encrypted, cipher.final()]);
        return encrypted.toString('hex');
    }
    
    // Decrypting text
    public static decrypt(input:string):string {
        let ivString = this.vars.ENCRYPT_IV;
        let keyString = this.vars.ENCRYPT_KEY;
        let keyBuffer = Buffer.from(keyString, 'hex');
        let encryptedText = Buffer.from(input, 'hex');
        let decipher = crypto.createDecipheriv(this.algorithm, Buffer.from(keyBuffer), Buffer.from(ivString, 'hex'));
        let decrypted = decipher.update(encryptedText);
        decrypted = Buffer.concat([decrypted, decipher.final()]);
        return decrypted.toString();
    }

    private static GetFullUrl(port: number, url: string, useSsl: boolean, isWebSocket:boolean = false): string 
    {
        let protocol:string = isWebSocket ? `ws` : `http`;
        if (useSsl) protocol += `s`;
        return (protocol) +
            `://` +
            `${url}` +
            `:` +
            `${port}`;
    }

    private static get MainConfig(): CONFIG.Config 
    {

        let corePort: number = parseInt(process.env.CORE_PORT as string);
        let coreHost: string = process.env.CORE_HOST as string;
        let coreUseSsl: boolean = process.env.CORE_USE_SSL as string == 'true';
        let coreFullUrl: string = this.GetFullUrl(corePort, coreHost, coreUseSsl);

        let publicPort: number = parseInt(process.env.PUBLIC_PORT as string);
        let publicHost: string = process.env.PUBLIC_HOST as string;
        let publicUseSsl: boolean = process.env.PUBLIC_USE_SSL as string == 'true';
        let publicFullUrl: string = this.GetFullUrl(publicPort, publicHost, publicUseSsl);
        let publicServerUrl: string = process.env.PUBLIC_SERVER_URL as string;

        let coreSocketPort: number = parseInt(process.env.CORE_SOCKET_PORT as string);
        let coreSocketHost: string = process.env.CORE_SOCKET_HOST as string;
        let coreSocketUseSsl: boolean = process.env.CORE_SOCKET_USE_SSL as string == 'true';
        let coreSocketFullUrl: string = this.GetFullUrl(coreSocketPort, coreSocketHost, coreSocketUseSsl);

        let publicSocketPort: number = parseInt(process.env.PUBLIC_SOCKET_PORT as string);
        let publicSocketHost: string = process.env.PUBLIC_SOCKET_HOST as string;
        let publicSocketUseSsl: boolean = process.env.PUBLIC_SOCKET_USE_SSL as string == 'true';
        let publicSocketFullUrl: string = this.GetFullUrl(publicSocketPort, publicSocketHost, publicSocketUseSsl);

        let publicColyseusPort: number = parseInt(process.env.PUBLIC_COLYSEUS_PORT as string);
        let publicColyseusHost: string = process.env.PUBLIC_COLYSEUS_HOST as string;
        let publicColyseusUseSsl: boolean = process.env.PUBLIC_COLYSEUS_USE_SSL as string == 'true';
        let publicColyseusFullUrl: string = this.GetFullUrl(publicColyseusPort, publicColyseusHost, publicColyseusUseSsl, true);

        let gameSocketPort: number = parseInt(process.env.GAME_PORT as string);
        let gameSocketHost: string = process.env.GAME_HOST as string;
        let gameSocketUseSsl: boolean = process.env.GAME_USE_SSL as string == 'true';
        let gameSocketFullUrl: string = this.GetFullUrl(gameSocketPort, gameSocketHost, gameSocketUseSsl);

        let mongodbCert:string = '';
        
        if (typeof process.cwd != 'undefined') {
            mongodbCert = path.resolve(__dirname, '..', '..', '..', process.env.MONGODB_CERT as string)
        } else {
            mongodbCert = process.env.MONGODB_CERT as string;
        }


        return {

            VERSION: "0.0.3",

            ENVIRONMENT: this.parseEnvironment(process.env.ENVIRONMENT as string),

            EXPRESS_SECRET: process.env.EXPRESS_SECRET as string,

            MONGODB_HOST: process.env.MONGODB_HOST as string,
            MONGODB_PORT: parseInt(process.env.MONGODB_PORT as string),
            MONGODB_DB: process.env.MONGODB_DB as string,
            MONGODB_USER: process.env.MONGODB_USER as string,
            MONGODB_PASS: process.env.MONGODB_PASS as string,
            MONGODB_CERT: mongodbCert,

            CLOUDINARY_NAME: process.env.CLOUDINARY_NAME as string,
            CLOUDINARY_KEY: process.env.CLOUDINARY_KEY as string,
            CLOUDINARY_SECRET: process.env.CLOUDINARY_SECRET as string,

            CORE_SOCKET_PORT: coreSocketPort,
            PUBLIC_SOCKET_PORT: publicSocketPort,
            PUBLIC_SOCKET_HOST: publicSocketHost,
            PUBLIC_SOCKET_FULL_URL: publicSocketFullUrl,
            PUBLIC_COLYSEUS_PORT: publicColyseusPort,
            PUBLIC_COLYSEUS_HOST: publicColyseusHost,
            PUBLIC_COLYSEUS_FULL_URL: publicColyseusFullUrl,
            CORE_PORT: corePort,
            CORE_FULL_URL: coreFullUrl,
            PUBLIC_FULL_URL: publicFullUrl,
            PUBLIC_SERVER_URL: publicServerUrl,

            PLAYCANVAS_AUTH_TOKEN: process.env.PLAYCANVAS_AUTH_TOKEN as string,

            NAKAMA_PORT: parseInt(process.env.NAKAMA_PORT as string),
            NAKAMA_HOST: process.env.NAKAMA_HOST as string,
            NAKAMA_HTTP_KEY: process.env.NAKAMA_HTTP_KEY as string,
            NAKAMA_SERVER_KEY: process.env.NAKAMA_SERVER_KEY as string,
            NAKAMA_USE_SSL: process.env.NAKAMA_USE_SSL as string == 'true',

            TWITTER_CLIENT_ID: process.env.TWITTER_CLIENT_ID as string,
            TWITTER_CALLBACK_URL: `${publicFullUrl}${twitterCallbackUrl}`,
            TWITTER_CLIENT_SECRET: process.env.TWITTER_CLIENT_SECRET as string,

            DISCORD_CLIENT_ID: process.env.DISCORD_CLIENT_ID as string,
            DISCORD_CALLBACK_URL: `${publicFullUrl}${discordCallbackUrl}`,
            DISCORD_CLIENT_SECRET: process.env.DISCORD_CLIENT_SECRET as string,

            SNAPCHAT_CLIENT_ID: process.env.SNAPCHAT_CLIENT_ID as string,
            SNAPCHAT_CALLBACK_URL: `${publicFullUrl}${snapchatCallbackUrl}`,
            SNAPCHAT_CLIENT_SECRET: process.env.SNAPCHAT_CLIENT_SECRET as string,

            GOOGLE_CLIENT_ID: process.env.GOOGLE_CLIENT_ID as string,
            GOOGLE_CALLBACK_URL: `${publicFullUrl}${googleCallbackUrl}`,
            GOOGLE_CLIENT_SECRET: process.env.GOOGLE_CLIENT_SECRET as string,

            VERIFY_EMAIL_SENDER: process.env.VERIFY_EMAIL_SENDER as string,
            VERIFY_EMAIL_PASSWORD: process.env.VERIFY_EMAIL_PASSWORD as string,

            ENCRYPT_IV: process.env.ENCRYPT_IV as string,
            ENCRYPT_KEY: process.env.ENCRYPT_KEY as string,

            TWILIO_ACCOUNT_SID: process.env.TWILIO_ACCOUNT_SID as string,
            TWILIO_AUTH_TOKEN: process.env.TWILIO_AUTH_TOKEN as string,
            TWILIO_VERIFY_SID: process.env.TWILIO_VERIFY_SID as string,

            ONESIGNAL_APP_ID: process.env.ONESIGNAL_APP_ID as string,
            ONESIGNAL_REST_API_KEY: process.env.ONESIGNAL_REST_API_KEY as string,

            CLOUDFLARE_ACCOUNT_ID: process.env.CLOUDFLARE_ACCOUNT_ID as string,
            CLOUDFLARE_R2_ACCESS_KEY_ID: process.env.CLOUDFLARE_R2_ACCESS_KEY_ID as string,
            CLOUDFLARE_R2_SECRET_ACCESS_KEY: process.env.CLOUDFLARE_R2_SECRET_ACCESS_KEY as string,
            CLOUDFLARE_R2_BUCKET_NAME: process.env.CLOUDFLARE_R2_BUCKET_NAME as string,
            
            GAME_PORT: gameSocketPort,
            GAME_HOST: gameSocketHost,
            GAME_FULL_URL: gameSocketFullUrl,

        };
    }
}

namespace CONFIG 
{
    export type Environment = 'ssl_development' | 'development' | 'production' | 'unknown';

    export const parseEnvironment = (input: string): Environment => 
    {
        if (input == 'development') {
            return 'development';
        } else if (input == 'production') {
            return 'production';
        } else if (input == 'ssl_development') {
            return 'ssl_development';
        } else {
            return 'unknown';
        }
    }

    export type Config = 
    {
        VERSION: string,

        ENVIRONMENT: Environment,

        EXPRESS_SECRET: string,

        MONGODB_HOST: string,
        MONGODB_PORT: number,
        MONGODB_DB: string,
        MONGODB_USER: string,
        MONGODB_PASS: string,
        MONGODB_CERT: string,

        CLOUDINARY_NAME: string,
        CLOUDINARY_KEY: string,
        CLOUDINARY_SECRET: string,

        PUBLIC_COLYSEUS_PORT: number,
        PUBLIC_COLYSEUS_HOST:string,
        PUBLIC_COLYSEUS_FULL_URL:string,

        PUBLIC_SOCKET_PORT: number,
        PUBLIC_SOCKET_HOST:string,
        PUBLIC_SOCKET_FULL_URL:string,

        CORE_SOCKET_PORT: number,
        CORE_PORT: number,
        CORE_FULL_URL: string,
        
        PUBLIC_FULL_URL: string,
        PUBLIC_SERVER_URL: string

        PLAYCANVAS_AUTH_TOKEN: string,

        NAKAMA_HOST: string,
        NAKAMA_PORT: number,
        NAKAMA_SERVER_KEY: string,
        NAKAMA_HTTP_KEY: string,
        NAKAMA_USE_SSL: boolean,

        TWITTER_CLIENT_ID: string,
        TWITTER_CALLBACK_URL: string,
        TWITTER_CLIENT_SECRET: string,

        DISCORD_CLIENT_ID: string,
        DISCORD_CALLBACK_URL: string,
        DISCORD_CLIENT_SECRET: string,

        SNAPCHAT_CLIENT_ID: string,
        SNAPCHAT_CALLBACK_URL: string,
        SNAPCHAT_CLIENT_SECRET: string,

        GOOGLE_CLIENT_ID: string,
        GOOGLE_CALLBACK_URL: string,
        GOOGLE_CLIENT_SECRET: string,

        VERIFY_EMAIL_SENDER: string,
        VERIFY_EMAIL_PASSWORD: string,

        ENCRYPT_IV: string,
        ENCRYPT_KEY: string,

        TWILIO_ACCOUNT_SID: string,
        TWILIO_AUTH_TOKEN: string,
        TWILIO_VERIFY_SID: string,

        ONESIGNAL_APP_ID: string,
        ONESIGNAL_REST_API_KEY: string,

        CLOUDFLARE_ACCOUNT_ID: string,
        CLOUDFLARE_R2_ACCESS_KEY_ID: string,
        CLOUDFLARE_R2_SECRET_ACCESS_KEY: string,
        CLOUDFLARE_R2_BUCKET_NAME: string,

        GAME_PORT: number,
        GAME_HOST:string,
        GAME_FULL_URL:string,
    };
}

export default CONFIG;

export const authenticationUrl: string = `/authentication`;

export const twitterAuthUrl: string = `/twitterAuth`;
export const twitterCallbackUrl: string = `/twitterCallback`;
export const twitterShareUrl: string = `/twitterShare`;

export const discordAuthUrl: string = `/discordAuth`;
export const discordCallbackUrl: string = `/discordCallback`;

export const googleAuthUrl: string = `/googleAuth`;
export const googleCallbackUrl: string = `/googleCallback`;

export const snapchatAuthUrl: string = `/snapchatAuth`;
export const snapchatCallbackUrl: string = `/snapchatCallback`;

export const emailSubscribe: string = `/emailSubscribe`;

export const authTokenize: string = `/authTokenize`;
export const authLinks: string = `/authLinks`;
export const authVerify: string = `/authVerify`;
export const authLogin: string = `/authLogin`;
export const authRegister: string = `/authRegister`;

export const cronHourly:string = `/cronHourly`;
export const cronDaily:string = `/cronDaily`;

export const fileUpload: string = `/fileUpload`;
export const fileGet: string = `/fileGet`;
export const fileTempPath: string = `/temp`;

export const storageUrl: string = `/storage`;

export const toyListUrl: string = `/toyList`;
export const toyArchiveUrl: string = `/toyArchive`;
export const toyArchiveAllUrl: string = `/toyArchiveAll`;
export const toyDeleteUrl: string = `/toyDelete`;
export const toyRemovePublicBuildUrl: string = `/toyRemovePublicBuild`;
export const toyBuildUrl: string = `/toyBuild`;
export const toySaveUrl: string = `/toySave`;
export const toyStatusUrl: string = `/toyStatus`;
export const toyTestUrl: string = `/toyTest`;

export const verifyRequestOTPUrl: string = `/verifyRequestOTP`;
export const verifySendOTPUrl: string = `/verifySendOTP`;

export const listSubscriberUrl: string = `/listSubscriber`;

export const evaluationUrl: string = `/evaluation`;

export const tokenizeUrl: string = `/tokenize`;